<template>
<v-main style="background: linear-gradient(317deg, rgba(34,150,150,0.4) 0%, rgba(253,187,45,0.4) 100%);height:100vh;">
<v-container>


 <v-card class="rounded-xl">
<v-card-text>

<div style="padding-bottom:20px;">
  <h1 style="padding-top:20px;padding-bottom:10px;">Covid Registration</h1>
  <div class="pre-text">Please sign in to our COVID-19 register.</div>
  <v-divider></v-divider>

  <div v-if="error">There was an error submitting your information.</div>
</div>
    <v-form  v-if="submitted==false"
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
      v-model="name"
      :counter="50"
      :rules="nameRules"
      label="Name"
      required
    ></v-text-field>

  <v-text-field
      v-model="mobile"
      :counter="50"
      :rules="nameRules"
      label="Mobile"
      required
    ></v-text-field>

    <v-text-field
      v-model="email"
      :rules="emailRules"
      label="E-mail"
      
    ></v-text-field>
  

<div class="mb-10 mt-10">
In line with the government requirements this data will be stored for 28 days and will be provided to the relevant bodies to assist with contract tracing if required.  
</div>
    <v-btn
      :disabled="!valid"
      color="success"
      class="mr-4"
      @click="validate"
    >
      Sign In
    </v-btn>

 

  
  </v-form>
  <div v-else class="mb-6">

    Thank you for submitting your details.

  </div>
</v-card-text>
 </v-card>
</v-container>


</v-main>
</template>

<script>

import axios from 'axios';
import {mapGetters} from 'vuex';

   export default {
    data: () => ({
      submitted:false,
      error:false,
      valid: true,
      name: '',
      mobile:'',
      nameRules: [
        v => !!v || 'required',
        v => (v && v.length <= 50) || 'must be less than 50 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
    
      checkbox: false,
    }),
  computed:{
      ...mapGetters(["getAxiosConfig"]),
    },
    methods: {
      validate () {
        var t = this;
        if(this.$refs.form.validate()){
               axios.post(
                  t.GLOBAL_CONFIG.apiURL + "api/Checkin/" + t.$route.params.location+"/" + t.$route.params.code,
                 {
  "name": t.name,
  "email": t.email,
  "mobile": t.mobile}
                  ).then(response=>{
                    if(response.data){
                        t.submitted = true;
                    }else{
                      t.error = true;
                    }
                    
                    
                    });


        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>
